import { ThirdPartyStatus } from '@risksmart-app/domain/src/types/consts/third-party-status';
import { ThirdPartyType } from '@risksmart-app/domain/src/types/consts/third-party-type';
import { z } from 'zod';

/**
 * The third-party form types `type`/`status` as plain `string` and
 * `criticality` as a nullish number (the form's own zod schema enforces the
 * real constraints). The tRPC hook input requires the strict domain enums for
 * Type/Status and an OPTIONAL `Criticality`. These helpers narrow the loose
 * GraphQL-shaped values to the strict tRPC shape at runtime WITHOUT `as`
 * casts — an invalid value throws before the mutation fires, matching the
 * server-side validation.
 */

const thirdPartyTypeSchema = z.nativeEnum(ThirdPartyType);
const thirdPartyStatusSchema = z.nativeEnum(ThirdPartyStatus);
// Mirror the server/router contract: the `Criticality` column is a NULLABLE
// integer with a DB CHECK (1..4). The form offers a blank "-" option, so a
// missing value must persist as null — but a present value is still 1..4.
const criticalitySchema = z.number().int().min(1).max(4).nullish();

export const toThirdPartyType = (
  value: string | null | undefined
): ThirdPartyType => thirdPartyTypeSchema.parse(value);

export const toThirdPartyStatus = (
  value: string | null | undefined
): ThirdPartyStatus => thirdPartyStatusSchema.parse(value);

export const toCriticality = (
  value: number | null | undefined
): number | null => criticalitySchema.parse(value) ?? null;
